import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "../../../components/Box";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RootState } from "../../../redux/store";
import { Helpers } from "../../../helpers/Helpers";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import { ConstantCategoryService } from "../../../services/ConstantCategoryService";
import { AddConstantCategoryResponse } from "../../../models/response/constantCategory/AddConstantCategoryResponse";
import { GetConstantCategoryByIdResponse } from "../../../models/response/constantCategory/GetConstantCategoryByIdResponse";
import { GetConstantListResponse } from "../../../models/response/constant/GetConstantListResponse";
import { ConstantService } from "../../../services/ConstantService";
import { AddConstantResponse } from "../../../models/response/constant/AddConstantResponse";
import { DeleteCountryResponse } from "../../../models/response/country/DeleteCountryResponse";
import ConstantCategoryDetail, { ConstantModel } from "./Components/ConstantCategoryDetail";
import toast from "react-hot-toast";

const ConstantCategoryAdd = () => {
    const auth = useSelector((state: RootState) => state.auth)
    const navigate = useNavigate();
    const pageName = "Genel Tanımlamalar > Sabit Tanımlamalar"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const [constantCategoryId, setConstantCategoryId] = useState<string | undefined>(undefined);
    const [shortName, setShortName] = useState('');
    const [longName, setLongName] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);
    const [constants, setConstants] = useState<ConstantModel[]>([]);
    const [tempConstantIds, setTempConstantIds] = useState<string[]>([]);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetConstantCategoryByIdResponse = await ConstantCategoryService.getConstantCategoryById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setConstantCategoryId(response.data.constantCategoryId);
                setShortName(response.data.code);
                setLongName(response.data.name);
                setIsDisabled(auth.user.user?.data.isAdmin ? false : response.data.companyId != auth.selectedCompany?.companyId)

                var response2: GetConstantListResponse = await ConstantService.getConstantList(response.data.code, undefined, undefined, true);

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                setConstants(response2.data.map(function (x) {
                    return {
                        constantId: x.constantId,
                        code: x.additionalValue1,
                        name: x.value,
                        isSelected: false,
                        isAdded: false,
                        companyId: x.companyId,
                        createdDate: x.createdDate,
                        createdUser: x.createdUser,
                        updatedDate: x.updatedDate,
                        updatedUser: x.updatedUser,
                        isCustomActive: x.isCustomActive
                    }
                }));

                setTempConstantIds(response2.data.map(x => x.constantId));
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const saveConstantCategory = async () => {
        try {
            if (Helpers.isEmpty(shortName))
                toast.error('Kodu alanını doldurunuz!')
            else if (Helpers.isEmpty(longName))
                toast.error('Adı alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var response: AddConstantCategoryResponse = await ConstantCategoryService.addConstantCategory(constantCategoryId, longName, shortName);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                for (var i = 0; i < constants.length; i++) {
                    var constant = constants[i];

                    var response2: AddConstantResponse = await ConstantService.addConstant(constant.isAdded ? undefined : constant.constantId, shortName, constant.name + '', undefined, constant.code, undefined, undefined, constant.isCustomActive);

                    if (!response2.isSuccess) {
                        toast.error(response2.message)
                        return;
                    }
                }

                var difference = tempConstantIds.filter(x => !constants.map(x => x.constantId).includes(x));

                if (difference && difference.length > 0) {
                    var response3: DeleteCountryResponse = await ConstantService.deleteConstant(difference);

                    if (!response3.isSuccess) {
                        toast.error(response3.message)
                        dispatch(storeActivityIndicator(false))
                        return;
                    }
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <KTCard className="ebbe-card">
                        <KTCardBody>
                            <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                            <div className='row'>
                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Kodu</label>
                                        <input disabled={isDisabled} style={{ border: '1px solid #F1F1F4' }} value={shortName} onChange={(e) => setShortName(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Adı</label>
                                        <input disabled={isDisabled} style={{ border: '1px solid #F1F1F4' }} value={longName} onChange={(e) => setLongName(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>
                                </div>
                            </div>
                        </KTCardBody>
                    </KTCard>

                    <ConstantCategoryDetail
                        constants={constants}
                        setConstants={setConstants}
                    />

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveConstantCategory}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default ConstantCategoryAdd;